import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { MapPin, Phone, Mail, Building2, Sparkles, Heart } from "lucide-react";

export default function About() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="max-w-5xl mx-auto px-6 pt-14 pb-16">
        <div className="overline text-[hsl(var(--primary))]">Quiénes somos</div>
        <h1 className="font-display text-5xl sm:text-6xl tracking-tight mt-2 leading-[1]">
          La empresa <span className="bg-gradient-to-r from-[#7C3AED] to-[#4C1D95] bg-clip-text text-transparent">detrás de OFERTAS</span>
        </h1>
        <p className="mt-5 text-base sm:text-lg text-muted-foreground max-w-3xl">
          OFERTAS es una marca de <strong>Marketing de Inteligencia Artificial S. de R.L. de C.V.</strong>, una empresa mexicana enfocada en acercar a los comercios locales y los vecinos de su colonia con tecnología de inteligencia artificial.
        </p>

        {/* Identity card */}
        <div className="mt-10 grid lg:grid-cols-5 gap-6">
          <div className="lg:col-span-3 bg-white border border-border rounded-2xl p-7" data-testid="about-company-card">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-11 h-11 rounded-xl bg-[hsl(var(--primary))]/10 grid place-items-center">
                <Building2 className="w-5 h-5 text-[hsl(var(--primary))]" />
              </div>
              <div>
                <div className="overline text-[hsl(var(--primary))] text-[11px]">Razón social</div>
                <div className="font-display text-2xl tracking-tight">Marketing de Inteligencia Artificial S. de R.L. de C.V.</div>
              </div>
            </div>
            <ul className="mt-6 space-y-4 text-base">
              <li className="flex gap-3">
                <MapPin className="w-5 h-5 text-[#7C3AED] shrink-0 mt-0.5" />
                <div>
                  <div className="text-xs uppercase tracking-wider text-muted-foreground">Domicilio</div>
                  <div>Av. Las Américas 1545, pisos 20, 21 y 22</div>
                  <div>Col. Providencia, Guadalajara, Jalisco, México</div>
                </div>
              </li>
              <li className="flex gap-3">
                <Phone className="w-5 h-5 text-[#7C3AED] shrink-0 mt-0.5" />
                <div>
                  <div className="text-xs uppercase tracking-wider text-muted-foreground">Teléfono</div>
                  <a href="tel:+523317381875" className="hover:text-[#7C3AED] font-mono">33 1738 1875</a>
                </div>
              </li>
              <li className="flex gap-3">
                <Mail className="w-5 h-5 text-[#7C3AED] shrink-0 mt-0.5" />
                <div>
                  <div className="text-xs uppercase tracking-wider text-muted-foreground">Correo</div>
                  <a href="mailto:hola@ofertas.mx" className="hover:text-[#7C3AED]">hola@ofertas.mx</a>
                </div>
              </li>
            </ul>
          </div>

          {/* Mission card */}
          <div className="lg:col-span-2 rounded-2xl bg-gradient-to-br from-[#7C3AED] via-[#6D28D9] to-[#4C1D95] text-white p-7 relative overflow-hidden">
            <div className="absolute -top-10 -right-10 w-48 h-48 rounded-full bg-amber-300/20 blur-3xl pointer-events-none" />
            <Sparkles className="w-7 h-7 text-amber-300" />
            <div className="overline text-amber-300 mt-3">Nuestra misión</div>
            <h3 className="font-display text-2xl tracking-tight mt-2 leading-tight">
              Que el comercio local mexicano viva y crezca con tecnología accesible.
            </h3>
            <p className="text-base text-white/85 mt-3">
              Creemos que la taquería de la esquina, la estética, la pizzería familiar y la papelería del barrio merecen las mismas herramientas que las grandes cadenas. Por $199 al mes, ahora las tienen.
            </p>
          </div>
        </div>

        {/* Values */}
        <div className="mt-12">
          <h2 className="font-display text-3xl sm:text-4xl tracking-tight">Lo que nos guía</h2>
          <div className="mt-6 grid md:grid-cols-3 gap-4">
            <Value title="Comercio local primero" body="Cada decisión técnica está al servicio del comerciante mexicano: barata, simple y útil desde el primer día." />
            <Value title="Tecnología que sirve" body="IA generativa para diseño de anuncios, QR para lealtad y boletos de rifa digitales. Nada de tecnología por moda." />
            <Value title="Sin letras chiquitas" body="Un solo precio, transferencia bancaria directa, sin contratos forzosos. Si no te funciona, te das de baja." />
          </div>
        </div>

        {/* Footer cta */}
        <div className="mt-12 bg-white border border-border rounded-2xl p-6 flex items-center gap-4 flex-wrap" data-testid="about-contact-block">
          <Heart className="w-6 h-6 text-rose-500" />
          <div className="flex-1 min-w-0">
            <div className="font-display text-xl">¿Quieres platicar con nosotros?</div>
            <div className="text-base text-muted-foreground">Escríbenos a hola@ofertas.mx o llámanos al 33 1738 1875.</div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

const Value = ({ title, body }) => (
  <div className="bg-white border border-border rounded-2xl p-5">
    <div className="font-display text-xl">{title}</div>
    <p className="text-base text-muted-foreground mt-2">{body}</p>
  </div>
);
